import script from "./rec-history-causes.vue?vue&type=script&lang=ts&setup=true"
export * from "./rec-history-causes.vue?vue&type=script&lang=ts&setup=true"

import "./rec-history-causes.vue?vue&type=style&index=0&id=1503cd78&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1503cd78"]])

export default __exports__